<template>
  <div class="border-container">
    <div class="border-container__item">
      <strong>{{ $t('style') }}</strong>
      <Dropdown :options="borderOptions" :value="border.style" @change="changed('style', $event)" />
    </div>

    <template v-if="border.style !== 'none'">
      <ColorPicker :label="$t('color')" :color="border.color" @submit="changed('color', $event)" />

      <div class="border-container__item">
        <strong>{{ $t('width') }} (px)</strong>
        <PlacementNumber :initial="border.width" @change="changed('width', $event)" />
      </div>

      <div class="border-container__item">
        <strong>{{ $t('radius') }} (px)</strong>
        <PlacementNumber :initial="border.radius" @change="changed('radius', $event)" />
      </div>
    </template>
  </div>
</template>

<script>
import ColorPicker from '@/shared/components/ColorPicker'
import PlacementNumber from '@/shared/components/PlacementNumber'
import Dropdown from '@/shared/components/Dropdown'

export default {
  name: 'Border',
  i18nOptions: { keyPrefix: 'components.sidenav.shared.border' },
  components: { Dropdown, ColorPicker, PlacementNumber },
  props: {
    border: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      borderOptions: [
        { value: 'solid', text: this.$i18n.t('components.sidenav.shared.border.line') },
        { value: 'dotted', text: this.$i18n.t('components.sidenav.shared.border.dotted') },
        { value: 'dashed', text: this.$i18n.t('components.sidenav.shared.border.dashed') },
        { value: 'none', text: this.$i18n.t('components.sidenav.shared.border.none') },
      ],
    }
  },
  methods: {
    changed(field, value) {
      this.$emit('change', { field, value })
    },
  },
}
</script>

<style lang="scss" scoped>
.border-container__item {
  margin-top: 16px;
}
</style>
